import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import RatioContainer from 'components/consumer/RatioContainer';
import JBProductImage from 'components/essentials/JBImage/JBProductImage';
import IconPlay from 'components/icons/IconPlay';
import PDPVideoPosterFrame from '../../PDPVideoPosterFrame';
const PDPDesktopFullScreenGallery2Thumbnail = t0 => {
  const $ = _c(21);
  const {
    cropData,
    enableCrops,
    isItemSelected,
    itemIndex,
    itemType,
    selectedThumbnailRef,
    setSelectedItemAndScroll,
    src,
    type,
    videoPosterUrl,
    videoThumbnailUrl
  } = t0;
  const [imageHasError, setImageHasError] = useState(false);
  if (imageHasError) {
    return null;
  }
  const t1 = isItemSelected ? selectedThumbnailRef : undefined;
  const t2 = !isItemSelected;
  let t3;
  if ($[0] !== isItemSelected || $[1] !== t2) {
    t3 = classNames("border border-solid [background:none] h-full w-full focus-visible:outline-offset-[-2px]", {
      "border-transparent": t2,
      "border-brand rounded-[3px] box-border [&_img]:rounded-[3px]": isItemSelected
    });
    $[0] = isItemSelected;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== itemIndex || $[4] !== setSelectedItemAndScroll) {
    t4 = () => {
      setSelectedItemAndScroll(itemIndex);
    };
    $[3] = itemIndex;
    $[4] = setSelectedItemAndScroll;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== cropData || $[7] !== enableCrops || $[8] !== itemType || $[9] !== src || $[10] !== type || $[11] !== videoPosterUrl || $[12] !== videoThumbnailUrl) {
    t5 = itemType === "video" ? <>{!!videoThumbnailUrl && <img className="h-auto" src={videoThumbnailUrl} alt="" />}{!videoThumbnailUrl && <PDPVideoPosterFrame className="h-full w-full object-cover" src={videoPosterUrl} />}<div className="left-[45px] pointer-events-none absolute top-[45px]"><IconPlay width={50} height={50} /></div></> : <JBProductImage ar="1:1" className="PDPDesktopFullScreenGallery2__gallery-image" cropFormat="1x1" crops={cropData} enableCrops={enableCrops} onError={() => {
      setImageHasError(true);
    }} size="10vw" sizes="10vw" src={src} type={type} />;
    $[6] = cropData;
    $[7] = enableCrops;
    $[8] = itemType;
    $[9] = src;
    $[10] = type;
    $[11] = videoPosterUrl;
    $[12] = videoThumbnailUrl;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t6 = <button className={t3} type="button" onClick={t4}>{t5}</button>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t1 || $[19] !== t6) {
    t7 = <RatioContainer wrapperClassName="h-[140px] w-[140px] [&_img]:cursor-pointer [&_img]:h-full [&_img]:object-cover [&_img]:w-full" ref={t1}>{t6}</RatioContainer>;
    $[18] = t1;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
PDPDesktopFullScreenGallery2Thumbnail.propTypes = {
  cropData: PropTypes.object,
  enableCrops: PropTypes.bool,
  isItemSelected: PropTypes.bool,
  itemIndex: PropTypes.number,
  itemType: PropTypes.string,
  selectedThumbnailRef: PropTypes.object,
  setSelectedItemAndScroll: PropTypes.func,
  src: PropTypes.string,
  type: PropTypes.string,
  videoPosterUrl: PropTypes.string,
  videoThumbnailUrl: PropTypes.string
};
export default PDPDesktopFullScreenGallery2Thumbnail;